'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { HowList } from '../../components/site/how-list'
import { Reveal } from '../../components/site/reveal'
import { SectionHead } from '../../components/site/section-head'
import { SiteSection } from '../../components/site/section'
import { TrialUploader } from './trial-uploader'

/**
 * 免費試轉。左邊上傳框、右邊三條說明；試轉區不包外框——只有上傳框自己的虛線
 * （那是「可以拖進來」的提示），三條說明直接排在頁面上。
 */
export function TrialSection() {
  const { t } = useTranslation(['web'])

  return (
    <SiteSection id="try" trackingKey="try">
      <Reveal>
        <SectionHead
          eyebrow={t('web:transcriptionPage.trial.eyebrow')}
          titleKey="web:transcriptionPage.trial.title"
        />
      </Reveal>
      <Reveal className="mt-(--gap-xl)">
        <div className="grid grid-cols-2 items-center gap-[clamp(28px,5vw,64px)] max-[860px]:grid-cols-1">
          <TrialUploader />
          <HowList
            variant="stack"
            items={['upload', 'result', 'signUp'].map((key) => ({
              title: t(`web:transcriptionPage.trial.steps.${key}Title`),
              description: t(`web:transcriptionPage.trial.steps.${key}Desc`),
            }))}
          />
        </div>
      </Reveal>
    </SiteSection>
  )
}
